import {mapRecordToItems} from "@/helpers/mapRecordToItems.helper";

export enum InvoiceFields {
    TITLE = 'title',
    INVOICE_NUMBER = 'invoiceNumber',
    INVOICE_DATE = 'invoiceDate',
    IS_CANCELED = 'isCanceled',
    DUE_DATE = 'dueDate',
    ITEMS = 'items',
    ACCOUNTING_REF = 'accountingRef',
    PUSHED_TO_ACCOUNTING_AT = 'pushedToAccountingAt',
    NET_TOTAL = 'netTotal',
    GROSS_TOTAL = 'grossTotal',
    VAT_TOTAL = 'vatTotal',
    STUDENT = 'student',
    CYCLE = 'cycle',
    PAID_STATE = 'paidState',
    PAID_AMOUNT = 'paidAmount',
    SERVICE_PERIOD = 'servicePeriod',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace InvoiceFields {
    type Data = {
        text: string;
        readonly?: boolean;
    };

    export const Record: Record<InvoiceFields, Data> = {
        [InvoiceFields.TITLE]: {
            text: 'Titel',
            readonly: true,
        },
        [InvoiceFields.INVOICE_NUMBER]: {
            text: 'Rechnungsnummer',
            readonly: true,
        },
        [InvoiceFields.INVOICE_DATE]: {
            text: 'Rechnungsdatum',
            readonly: true,
        },
        [InvoiceFields.DUE_DATE]: {
            text: 'Fälligkeitsdatum',
            readonly: true,
        },
        [InvoiceFields.ITEMS]: {
            text: 'Rechnungspositionen',
            readonly: true,
        },
        [InvoiceFields.ACCOUNTING_REF]: {
            text: 'Buchhaltungsreferenz',
            readonly: true,
        },
        [InvoiceFields.PUSHED_TO_ACCOUNTING_AT]: {
            text: 'Buchhaltungsdatum',
            readonly: true,
        },
        [InvoiceFields.NET_TOTAL]: {
            text: 'Nettobetrag',
            readonly: true,
        },
        [InvoiceFields.GROSS_TOTAL]: {
            text: 'Bruttobetrag',
            readonly: true,
        },
        [InvoiceFields.VAT_TOTAL]: {
            text: 'Umsatzsteuer',
            readonly: true,
        },
        [InvoiceFields.STUDENT]: {
            text: 'Schüler',
            readonly: true,
        },
        [InvoiceFields.CYCLE]: {
            text: 'Rechnungslauf',
            readonly: true,
        },
        [InvoiceFields.PAID_STATE]: {
            text: 'Zahlungsstatus',
        },
        [InvoiceFields.PAID_AMOUNT]: {
            text: 'Bezahlter Betrag',
        },
        [InvoiceFields.SERVICE_PERIOD]: {
            text: 'Leistungszeitraum',
            readonly: true,
        },
        [InvoiceFields.CREATED_AT]: {
            text: 'Erzeugungsdatum',
            readonly: true,
        },
        [InvoiceFields.UPDATED_AT]: {
            text: 'Änderungsdatum',
            readonly: true,
        },
        [InvoiceFields.IS_CANCELED]: {
            text: 'Storniert',
        },
    };

    export const Items = mapRecordToItems(Record);
}
